import { describe, expect, it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  BILL_TO_ADDRESS_FIELDS
} from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages, { type Card, type Field, type Page } from '..';

describe('BillTo Page Template', () => {
  it('exports one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const billToPage = pages.find(page => page.route === PAGE_ROUTES.company) as Page;

  describe('BillTo Page Structure', () => {
    it('has correct route', () => {
      expect(billToPage).toBeDefined();
      expect(billToPage.route).toBe(PAGE_ROUTES.company);
    });

    it('contains expected cards', () => {
      expect(Array.isArray(billToPage.cards)).toBe(true);
      expect(billToPage.cards).toHaveLength(3);
    });
  });

  describe('BillTo Address Card', () => {
    const billToCard = billToPage.cards!.find(
      card => card.key === CARD_CATEGORIES.billTo
    ) as Card;

    it('has hideSameAs enabled', () => {
      expect(billToCard).toBeDefined();
      expect(billToCard.hideSameAs).toBe(true);
    });

    it('has correct fields', () => {
      expect(billToCard.fields?.map((f: Field) => f.key)).toEqual([
        BILL_TO_ADDRESS_FIELDS.address,
        BILL_TO_ADDRESS_FIELDS.taxNumber2,
        BILL_TO_ADDRESS_FIELDS.taxNumber3
      ]);
    });
  });

  describe('Attachment Card', () => {
    it('contains additionalAttachmentCard with correct field', () => {
      const attachmentCard = billToPage.cards!.find(
        card => card.key === CARD_CATEGORIES.additionalAttachmentCard
      ) as Card;

      expect(attachmentCard).toBeDefined();
      expect(attachmentCard.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });
  });

  describe('Privacy Policy Card', () => {
    it('exists and has no fields', () => {
      const privacyCard = billToPage.cards!.find(
        card => card.key === CARD_CATEGORIES.privacyPolicy
      ) as Card;

      expect(privacyCard).toBeDefined();
      expect(privacyCard.fields).toBeUndefined();
    });
  });
});
